import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadFileToServerComponent } from './components/upload-file-to-server/upload-file-to-server.component';
import { ConfirmPrintingFileModalComponent } from './modals/confirm-printing-file-modal/confirm-printing-file-modal.component';
import { PrintFileFromDeviceModalComponent } from './modals/print-file-from-device-modal/print-file-from-device-modal.component';
import { SharedModule } from '@shared/shared.module';
import { AccountSharedModule } from '../account/account-shared.module';
import { FileBrowserModule } from '../file-browser/file-browser.module';

@NgModule({
  declarations: [
    UploadFileToServerComponent,
    
    ConfirmPrintingFileModalComponent,
    PrintFileFromDeviceModalComponent
  ],
  exports: [
    UploadFileToServerComponent,
    
    ConfirmPrintingFileModalComponent,
    PrintFileFromDeviceModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FileBrowserModule,
    AccountSharedModule
  ]
})
export class PrintFileSharedModule {
  
}
